import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  styled,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { ShoppingCartButton } from "./ShoppingCartButton";

import { useAppDispatch, useAppSelector } from "../hooks/hooks";

interface ChatHeaderProps {
  title: string;
  onBack: () => void;
  onlineStatus?: string;
  lastSeen?: string;
}

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  color: theme.palette.text.primary,
  boxShadow: theme.shadows[1],
}));

const ChatHeader: React.FC<ChatHeaderProps> = ({
  title,
  onBack,
  onlineStatus,
  lastSeen,
}) => {
  const dispatch = useAppDispatch();
  const { giftBrands } = useAppSelector((state) => state.shoppingCart);
  return (
    <StyledAppBar position="sticky">
      <Toolbar>
        <IconButton
          edge="start"
          color="inherit"
          onClick={onBack}
          aria-label="back"
          sx={{ mr: 2 }}
        >
          <ArrowBackIcon />
        </IconButton>

        <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
          <Typography
            variant="h6"
            noWrap
            sx={{ fontWeight: 600, lineHeight: 1.2 }}
          >
            {title}
          </Typography>

          {onlineStatus && (
            <Typography
              variant="caption"
              sx={{ display: "block", lineHeight: 1.2 }}
              color="textSecondary"
            >
              {onlineStatus}
            </Typography>
          )}

          {lastSeen && (
            <Typography
              variant="caption"
              sx={{ display: "block", lineHeight: 1.2 }}
              color="textSecondary"
            >
              Last seen {lastSeen}
            </Typography>
          )}
        </Box>
      </Toolbar>
    </StyledAppBar>
  );
};

export default ChatHeader;
